<template>
    <div class="measure-tool-ctrl">
        <div class="measure-tool-title">{{ title }}</div>
        <a @click="start" class="measure-tool-ctrl-btn" :class="{ active: status }">+</a>
        <a @click="init" class="measure-tool-ctrl-btn">{{clear_text}}</a>

        <measure-item
            v-for="(item, key) in measure_items"
            :key="key"
            :options="item"
            :measure_tool="tool"
        ></measure-item>
    </div>
</template>

<script>
import Vue from "vue"

import MeasureItem from './measure-item.vue' //編輯多角形元件

export default {
    name: 'measure-tool',
    components: {
        'measure-item': MeasureItem,
    },
    props: ['cursor_latlng', 'tool'],
    data: function() {
        return {
            status: false,
            pane_name: 'measure-tool',
            pane: null,
            count: 0,
            color: this.tool.options.color || '#ff2a2a',
            unit: this.tool.options.unit || 'km', //m|km
            show_distance: this.tool.options.show_distance === false ? false : true,
            show_center_btn: this.tool.options.show_center_btn === false ? false : true,
            show_area: this.tool.options.show_area === false ? false : true,
            radius: 250,
            cursor_marker: null, //滑鼠hover顯示的marker
            first_marker: null, //polyline起始點的marker
            last_marker: null, //polyline末端點的marker
            cursor_distance_marker: null, //滑鼠hover顯示距離的marker
            last_marker_latlng: null,
            measure_markers: [], //繪製點marker
            measure_distance_markers: [], //繪製點marker
            measure_polyline: null, //marker連接之polyline
            measure_polyline_latlngs: [], //marker連接之polyline的經緯度
            measure_items: {},

            // qplus
            order_tool: this.tool.options.order_tool,
            opacity_tool: this.tool.options.opacity_tool,
            pane_tag_tool: this.tool.options.pane_tag_tool,
        }
    },
    computed: {
        title() {
            return this.tool.options.title || 'Measure Tool'
        }, 
        finish_btn_txt() {
            return this.tool.options.finish_btn_txt || 'Click to finish'
        },
        clear_text() {
            return this.tool.options.clear_text || 'Clear'
        },
    },
    mounted: function () {
        this.tool.init = this.init
        this.tool.start = this.start
        this.tool.stop = this.stop
        this.tool.get = this.get
        this.tool.reset = this.reset
        this.tool.get_center_latlng = this.get_center_latlng
        this.tool.get_distance = this.get_distance
        this.tool.get_format_distance = this.get_format_distance
        this.tool.get_area = this.get_area
        this.tool.get_format_area = this.get_format_area
        this.tool.get_count = this.get_count
    },
    methods: {
        init: function() {
            Object.keys(this.measure_items).forEach((key) => {
                this.delete_item(key)
            })
            this.reset_tool()

            // create pane for draw measure tool
            this.$emit('create_layer', {
                name: this.pane_name,
                text: 'Measure Tool',
                type: 'empty',
                pane_type: 'top',
                order_tool: this.order_tool,
                opacity_tool: this.opacity_tool,
                pane_tag_tool: this.pane_tag_tool,
                callback: (options, pane) => {
                    this.pane = pane

                    // initial cursor marker
                    this.cursor_marker = L.marker([90, 180], {
                        pane: this.pane_name,
                        icon: L.divIcon({
                            className: 'measure-tool-cursor-marker',
                        }),
                        riseOnHover: true,
                        riseOffset: 999,
                    }).addTo(pane)

                    // initial first marker: for close polygon
                    this.first_marker = L.marker([90, 180], {
                        pane: this.pane_name,
                        icon: L.divIcon({
                            iconSize: [20, 20],
                            className: 'measure-tool-measure-first-marker',
                        }),
                        riseOnHover: true,
                        riseOffset: 999,
                    })
                        .addTo(pane)
                        .bindTooltip(this.finish_btn_txt)

                    this.first_marker.on('click', (e) => {
                        this.finish_measure(e.latlng, 'area')
                    })

                    // initial last marker: for close polyline
                    this.last_marker = L.marker([90, 180], {
                        pane: this.pane_name,
                        icon: L.divIcon({
                            iconSize: [20, 20],
                            className: 'measure-tool-end-marker',
                        }),
                        riseOnHover: true,
                        riseOffset: 999,
                    })
                        .addTo(pane)
                        .bindTooltip(this.finish_btn_txt)

                    this.last_marker.on('click', (e) => {
                        this.finish_measure(e.latlng, 'line')
                    })

                    // initial cursor distance marker
                    this.cursor_distance_marker = L.circle([90, 180], {
                        pane: this.pane_name,
                        color: 'transparent',
                    })
                        .addTo(pane)
                        .bindTooltip('-- m', {
                            direction: 'center',
                            permanent: true,
                            className: 'measure-tool-distance-tag',
                        })
                        .openTooltip()

                    // initial polyline
                    this.measure_polyline = L.polyline([], {
                        pane: this.pane_name,
                        color: this.color,
                        weight: 1,
                        dashArray: 5,
                        noClip: true,
                        interactive: false,
                        renderer: L.svg(),
                    }).addTo(pane)

                    // click map to add marker
                    this.cursor_marker.on('click', (e) => {
                        // click first marker => draw polygon
                        const marker = L.circle(e.latlng, {
                            pane: this.pane_name,
                            radius: this.radius,
                            color: this.color,
                        }).addTo(pane)

                        if (!this.last_marker_latlng) {
                            //is first marker
                            this.first_marker.setLatLng(e.latlng)
                        } else {
                            // is n ~ last marker
                            this.add_distancd_tag(e.latlng)
                            this.last_marker.setLatLng(e.latlng)
                        }

                        this.last_marker_latlng = e.latlng
                        this.measure_markers.push(marker)
                        this.measure_polyline_latlngs.push(e.latlng)
                    })
                },
            })
        },
        start: function() {
            if (!this.pane) {
                this.init()
            }
            this.status = true
        },
        stop: function() {
            this.status = false
            this.reset_tool()
        },
        get: function() {
            return Object.keys(this.measure_items).map((key) => {
                return this.measure_items[key].latlngs
            })
        },
        reset: function() {
            this.status = false
            this.reset_tool()

            this.$emit('clear_pane', this.pane_name)
        },
        get_count: function() {
            return this.count
        },
        get_format_distance: function(latlng1, latlng2, unit = this.unit) {
            let distance = this.get_distance(latlng1, latlng2) //m
            if (unit === 'km') {
                distance = distance / 1000
            }

            return distance.toFixed(2) + ' ' + unit
        },
        get_format_area: function(latlngs, unit = this.unit) {
            let area = this.get_area(latlngs) //m²

            if (unit === 'km') {
                area = area / 1000000
            }

            return area.toFixed(2) + ' ' + unit + '²'
        },
        get_center_latlng: function(latlng1, latlng2) {
            // get two points center latlng
            return {
                lat: (latlng1.lat + latlng2.lat) / 2,
                lng: (latlng1.lng + latlng2.lng) / 2,
            }
        },
        get_distance: function(latlng1, latlng2) {
            // get distance(m) by two points latlngs
            return latlng1.distanceTo(latlng2)
        },
        get_area: function(path) {
            // get area(m²) by more than 3 points latlngs
            if (path.length < 3) {
                return null
            }

            const path_length = path.length
            const radius = 6378137
            const start_point = path[path_length - 1]

            let prevTanLat = _get_tan_lat(start_point.lat)
            let prevLng = _get_lng_radian(start_point.lng)
            let total = 0
            for (let i in path) {
                const tanLat = _get_tan_lat(path[i].lat)
                const lng = _get_lng_radian(path[i].lng)

                total += _get_triangle_area(tanLat, lng, prevTanLat, prevLng)
                prevTanLat = tanLat
                prevLng = lng
            }

            return Math.abs(total * (radius * radius))

            function _get_tan_lat(lat) {
                return Math.tan((Math.PI / 2 - (lat / 180) * Math.PI) / 2)
            }
            function _get_lng_radian(lng) {
                return (lng / 180) * Math.PI
            }

            function _get_triangle_area(tan1, lng1, tan2, lng2) {
                const deltaLng = lng1 - lng2
                const t = tan1 * tan2
                return 2 * Math.atan2(t * Math.sin(deltaLng), 1 + t * Math.cos(deltaLng))
            }
        },
        add_distancd_tag: function(latlng) {
            // add distance tag between last marker and this latlng
            const last_latlng = this.last_marker_latlng
            const distance_tag_latlng = this.get_center_latlng(last_latlng, latlng)
            const distance = this.get_format_distance(last_latlng, latlng)

            const tag_marker = L.circle(distance_tag_latlng, {
                pane: this.pane_name,
                color: 'transparent',
            })
                .addTo(this.pane)
                .bindTooltip(distance, {
                    direction: 'center',
                    permanent: true,
                    className: 'measure-tool-distance-tag',
                })
                .openTooltip()

            this.measure_distance_markers.push(tag_marker)
        },
        finish_measure: function(latlng, type) {
            const measure_latlngs = this.measure_polyline_latlngs.slice()
            this.add_distancd_tag(latlng)
            this.create_measure_item(measure_latlngs, type)
        },
        create_measure_item: function(latlngs, type) {
            const key = +new Date()
            this.measure_items[key] = {
                pane_name: this.pane_name,
                pane: this.pane,
                type: type,
                show_area: this.show_area,
                show_distance: this.show_distance,
                show_center_btn: this.show_center_btn,
                latlngs: latlngs,
                unit: this.unit,
                color: this.color,
                dragged: (latlngs, e) => {},
                destory: () => {
                    this.delete_item(key)
                },
            }

            this.reset_tool()
            this.status = false
            this.count++
        },
        delete_item: function(key) {
            Vue.delete(this.measure_items, key)
            this.count--

            if (!this.tool.after_delete) {
                return
            }
            this.tool.after_delete()
        },
        reset_tool: function() {
            this.measure_markers.concat(this.measure_distance_markers).forEach((o) => {
                o.remove()
            })

            this.last_marker_latlng = null
            this.measure_markers = []
            this.measure_distance_markers = []
            this.measure_polyline_latlngs = []

            if (this.cursor_marker) {
                this.cursor_marker.setLatLng([90, 180])
            }
            if (this.first_marker) {
                this.first_marker.setLatLng([90, 180])
            }
            if (this.last_marker) {
                this.last_marker.setLatLng([90, 180])
            }
            if (this.cursor_distance_marker) {
                this.cursor_distance_marker.setLatLng([90, 180])
            }
            if (this.measure_polyline) {
                this.measure_polyline.setLatLngs([])
            }
        },
    },
    watch: {
        cursor_latlng: function(latlng) {
            if (!this.status) {
                return
            }

            // move marker & polyline by cursor
            this.cursor_marker.setLatLng(latlng)
            this.measure_polyline.setLatLngs(this.measure_polyline_latlngs.concat(latlng))

            // draw distance tag
            if (this.last_marker_latlng) {
                const last_latlng = this.last_marker_latlng
                const distance_tag_latlng = this.get_center_latlng(last_latlng, latlng)
                const distance = this.get_format_distance(last_latlng, latlng)
                this.cursor_distance_marker.setLatLng(distance_tag_latlng).setTooltipContent(distance)
            }
        },
    },
}
</script>

<style>
.measure-tool-cursor-marker {
    cursor: copy;
    background-color: rgba(255, 255, 255, 0.3);
    border-radius: 50%;
}
.measure-tool-measure-first-marker,
.measure-tool-end-marker {
    background-color: #666;
    border-radius: 50%;
    border: 0.06em solid #eee;
}
.leaflet-tooltip.measure-tool-distance-tag {
    padding: 0.1em;
    font-family: monospace;
    line-height: 1;
    color: #909399;
}
</style>

<style scoped>
.measure-tool-ctrl {
    padding: 0.4em;
    color:white;
    background-color: #191f35;
}

.measure-tool-title {
    font-size: 0.8em;
    margin-bottom: 0.5em;
}

.measure-tool-ctrl-btn {
    background-color: rgba(255, 255, 255, 0.5);
    display: inline-block;
    padding: 0.1em 0.4em;
    border: 0.063em solid #aaa;
    border-radius: 0.188em;
    color: #ffffff;
}

.measure-tool-ctrl-btn:hover {
    color: #ffffff;
    background-color: rgba(44, 253, 225, 0.6);
    cursor: pointer;
}

.measure-tool-ctrl-btn.active {
    color: #fff;
    background-color: rgba(44, 253, 225, 0.6);
    transition: 0.2s;
}
</style>
